// extracted by mini-css-extract-plugin
module.exports = {"caseTip":"ChooseCase_style_caseTip__2tFQ6","hideSelectAll":"ChooseCase_style_hideSelectAll__2q2pZ","has-error":"ChooseCase_style_has-error__3aJyg"};